import App from './genuary/App.svelte';
const app = new App({
    target: document.body,
    props: {}
});
export default app;
